module.exports = __webpack_public_path__ + "blessing.d493b012.png";